import { Button, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import KeyboardBackspaceOutlinedIcon from '@mui/icons-material/KeyboardBackspaceOutlined';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import styled from '@emotion/styled';


export const PopupTitle = styled(DialogTitle)(({ theme }) => `
text-align: center;
font-size: 16px;
padding: 10px 16px;
@media (min-width: 600px){
    padding: 16px 24px;
    font-size: 18px;
  }
`);

export const DialogContentStyled = styled(DialogContent)(() => `
padding: 10px 16px;
@media (min-width: 600px){
    padding: 16px 24px;
  }
`);

export const DescriptionStyled = styled.p`
text-align: center;
font-size: 14px;
@media (min-width: 600px){
     font-size: 16px;
  }
`;

export const WrapperMissingAnswers = styled('div')(({ theme }) => `
display: flex;
flex-wrap: wrap;
justify-content: center;
align-items: center;
gap: 4px;
max-width: 300px;
margin-top: 10px;
`);

export const CircleNumberMissingAnswers = styled('span')(({ theme }) => `
display: inline-flex;
justify-content: center;
align-items: center;
width: 30px;
height: 30px;
border-radius: 50%;
background-color: ${theme.palette.common.black};
color: ${theme.palette.common.white};
font-size: 14px;
`);

export const WrapperActions = styled(DialogActions)`
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
gap: 20px;
min-width: 100%;
padding: 10px 16px;
@media (min-width: 600px){
    padding: 16px 24px;
  }
`;

export const ButtonStyled = styled(Button)(({ theme, color }) => `
width: 100%;
&:not(:first-of-type) {
    margin-left: 0;
}
`);

export const BackIconStyled = styled(KeyboardBackspaceOutlinedIcon)(() => `
margin-right:10px;
font-size: 20px;
`);

export const SendIconStyled = styled(SendOutlinedIcon)(() => `
margin-right:10px;
font-size: 20px;
`);




